(function() {
    'use strict';
    angular.module('wbDashboard').directive('autoDepositScheduler', ['$window', '$timeout', function($window, $timeout) {
    return {
        restrict: 'E',
        scope: {
            autos: '=', //data binding
            newAutos: '=?' //data binding
        },
        templateUrl: "app/themes/aurea/directives/auto-deposit/auto-deposit.tpl.html",
        link: function(scope, el, attrs) {

            if (!scope.newAutos) {
                scope.readOnly = true;
                scope.newAutos = {};
            }

            scope.options = {
                whichWeek: []
            };
            scope.days = {'Mon': 'Monday', 'Tue': 'Tuesday', 'Wed': 'Wednesday', 'Thu': 'Thursday', 'Fri': 'Friday'};
            scope.dates = [];
            for (var i = 1; i <= 30; i += 1) {
                scope.dates.push(i);
            }

            //Add new date to selected frequency for month types
            //limit to 1 selected for monthly and 2 selected for twice-monthly
            scope.addFrequencyDate = function(date) {
                if (scope.newAutos.frequency_dates.indexOf(date) === -1) {
                    scope.newAutos.frequency_dates.push(date);
                } else {
                    scope.newAutos.frequency_dates.splice(scope.newAutos.frequency_dates.indexOf(date), 1);
                }

                //make sure there aren't too many items
                if (scope.newAutos.frequency === 'Monthly' && scope.newAutos.frequency_dates.length > 1) {
                    scope.newAutos.frequency_dates = scope.newAutos.frequency_dates.slice(-1);
                }
                if (scope.newAutos.frequency === 'Twice-Monthly' && scope.newAutos.frequency_dates.length > 2) {
                    scope.newAutos.frequency_dates = scope.newAutos.frequency_dates.slice(-2);
                }
            };

            //make sure month selection has correct days selected
            scope.validateDates = function(dates) {
                if (dates) {
                    if (scope.newAutos.frequency === 'Monthly') {
                        return dates.length === 1;
                    }
                    if (scope.newAutos.frequency === 'Twice-Monthly') {
                        return dates.length === 2;
                    }
                }
                return false;
            };

            scope.$watch('newAutos.frequency', function(frequency) {
                scope.newAutos.frequency_start_date = null;
                scope.newAutos.frequency_dates = null;
                scope.newAutos.frequency_weekday = null;

                if (frequency === scope.autos.frequency) {
                    // scope.newAutos.frequency_dates = angular.copy(scope.autos.frequency_dates);
                    // scope.newAutos.frequency_weekday = scope.autos.frequency_weekday;
                    switch (frequency) {
                        case "Weekly":
                            scope.newAutos.frequency_weekday = scope.autos.frequency_weekday;
                            break;
                        case "Monthly":
                        case "Twice-Monthly":
                            scope.newAutos.frequency_dates = angular.copy(scope.autos.frequency_dates);
                            break;
                        case "Bi-Weekly":
                            scope.newAutos.frequency_weekday = scope.autos.frequency_weekday;
                            break;
                    }
                } else {

                    switch (frequency) {
                        case "Weekly":
                            scope.newAutos.frequency_weekday = "Monday";
                            break;
                        case "Monthly":
                            scope.newAutos.frequency_dates = [1];
                            break;
                        case "Twice-Monthly":
                            scope.newAutos.frequency_dates = [1, 15];
                            break;
                        case "Bi-Weekly":
                            scope.newAutos.frequency_weekday = "Monday";
                            setFrequencyDate(scope.newAutos.frequency_weekday);
                            break;
                        case "Quarterly":
                            break;
                        default:
                            scope.newAutos.frequency = scope.autos.frequency;
                    }
                }
            });
            scope.$watch('newAutos.frequency_weekday', function(weekday) {
                if (weekday && scope.newAutos.frequency === 'Bi-Weekly') {
                    setFrequencyDate(weekday);
                }

            });
            function setFrequencyDate (weekday) {
                var index = 0;

                //get current index to set it to same index value after new whichWeek array is created
                scope.options.whichWeek.forEach(function (value, key) {
                    if (value.value === scope.newAutos.frequency_start_date) {
                        index = key;
                    }
                });

                scope.options.whichWeek = [
                    {text: "Start " + weekday + " Of This Week", value: moment().day(weekday).format("MM/DD/YYYY")},
                    {text: "Start " + weekday + " Of Next Week", value: moment().day(weekday).add(7,'days').format("MM/DD/YYYY")}
                ];

                if (!scope.newAutos.frequency_start_date) {
                    //if no start date is selected, attempt to make it match current setting
                    scope.options.whichWeek.forEach(function (value, key) {
                        if (value.value === scope.autos.frequency_start_date) {
                            index = key;
                        }
                    });
                }

                scope.newAutos.frequency_start_date = scope.options.whichWeek[index].value;
            }

        }};
    }]);
})();
